(function() {
  angular.module("irricrops")
    .factory('SensorFac', [function () {

      //obtiene deltas de dia en array de datos
      //con formato [unix, data]
      var getConsumos = function(data, valid){
        var lastData = data[0];
        var result = [];
        _.each(data, function(d){
          if(!moment(lastData[0]).isSame(d[0], "day")){
            var diff =  _.round(lastData[1] - d[1], 1);
            result.push([lastData[0],diff]);
            lastData = d;
          }
        });
        if(data.length > 0){
          result.push([
            data[data.length - 1][0],
            _.round(lastData[1] - data[data.length - 1][1], 1)
          ])
        }
        if(valid){
          _.each(valid, function(validDay){
            var v_m = moment(validDay[0]).utc();
            _.each(result, function(resultDay){
              var r_m = moment(resultDay[0]);
              if(r_m.isSame(v_m, "day") && validDay[1] == 0){
                resultDay[1] = null;
              }
            });
          });
        }

        var promedio = 0;
        var valid = 0;
        _.each(result, function(r){
          if(r[1] > 0){
          valid++;
            promedio += r[1];
          }
        });

        var ultimo = null;
        if(data.length > 0){
          ultimo = data[data.length -1][1];
        }
        return {
          data     : result,
          promedio : promedio,
          ultimo   : ultimo
        };
      }


        /*
         * se obtiene pendiente de 2 numeros,
         * usado para suma de sensores
         */
        var pendiente = function(y1, y2){
         return Math.abs(y2 - y1);
        }


        /*
         * se verifican las pendientes de los datos obtenido desde
         * la serie de suma de sensores
         * pendiente valida = 10
         * pendiente invalida = 0
         */
        var getValidTimes = function(param){
          var last       = null;
          var arr        = param.data;
          var tolerancia = -1;
          var result     = [];
          var pendientes = [];
          _.each(arr, function(item, i){
            var v = 0; // false , validez
            var p = 0;
            if(last){
              p = item[1] - last[1]; //pendiente
              if(p > tolerancia){
                v = 10;
                if(param.cc && param.cc < item[1]){
                  v = 0;
                }
                if(param.ur && param.ur > item[1]){
                  v = 0;
                }
              }
            }
            result.push([
              item[0],
              v
            ]);
            pendientes.push([
              item[0],
              p
            ]);
            last = item;
          });
          return {
            valid: result,
            pendientes: pendientes
          }
        }

      var getValidDays = function(params){
        var tolerancia = params.tolerancia;
        var validTimes = getValidTimes(params);
        var validData  = validTimes.valid;
        var lastData   = validData[0];
        var result     = [];
        var total      = 0;
        var validos    = 0;
        _.each(validData, function(d){
          //IF entra cuando el dato es de un dia distinto
          if(!moment(lastData[0]).isSame(d[0], "day")){
            var diff =  _.round(lastData[1] - d[1], 1);
            var v = 0;
            var porcentajeValidez = _.round((validos/total)*100, 2);
            if(porcentajeValidez >= tolerancia){
              v = 100
            }
            result.push([lastData[0],v]);
            total    = 0;
            validos  = 0;
            lastData = d;
          }
          total++;
          if(d[1] > 0){
            validos++;
          }
        });
        return {
          days       : result,
          all        : validData,
          pendientes : validTimes.pendientes
        }
      };


        /*
         * recibe un objecto moment y un array 
         * para busqueda por fecha
         * el array debe tener un parametro [0] unix o 
         * compatible con moment(X)
         */
        var getByMoment = function(m, arr){
          var r = null; 
          _.each(arr, function(a){
            if(r === null && moment(a[0]).isSame(m, "day")){
              r = a[1];
            }
          });
          return r;
        }











      return {
        getConsumos   : getConsumos,
        getValidTimes : getValidTimes,
        getValidDays  : getValidDays

      }


      
    }]);
  }());
